import type { Order } from '@seen/core/models/orders/Order'
import { TypographyDetail } from '@seen/ui'
import type { JSX } from 'react'
import { OrderMention } from '#src/components/OrderMention.tsx'

export function OrderSplitToast({
  originalOrder,
  resultingOrders,
}: {
  originalOrder: Order
  resultingOrders: Order[]
}): JSX.Element | null {
  if (!resultingOrders.length) {
    return null
  }

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3">
      <div className="flex flex-col gap-2">
        <TypographyDetail>Order split</TypographyDetail>
        <p className="text-xs text-secondary-foreground">
          The order was automatically split into separate orders based on lab
          requirements.
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-secondary-foreground">
            Original order
          </span>
          <div className="flex">
            <OrderMention
              order={originalOrder.reference}
              className="truncate"
            />
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-secondary-foreground">
            Resulting Orders
          </span>
          {resultingOrders.map((order) => (
            <div key={order.id} className="flex flex-col">
              <div className="flex">
                <OrderMention order={order.reference} className="truncate" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
